import { AbstractLayerSettingsState } from '../toolbars/layer-settings/abstract-layer-settings-state';

export const DEFAULT_BRIGHTNESS = 50;
export const DEFAULT_CONTRAST = 50;
export const DEFAULT_OPACITY = 20;
export const DEFAULT_RASTER_OPACITY = 25;

export class LayerSettingsState2D extends AbstractLayerSettingsState {
  showShapeDimensions = true;
  hideOccludedShapes = false;
  brightness = DEFAULT_BRIGHTNESS;
  contrast = DEFAULT_CONTRAST;
  zoomPanelScale = 5;
  zoomPanelEnabled = true;
  altImageEnabled = true;
  alwaysShowSubpoints = false;
  swapLayerOnSelect = true;

  constructor(opacity: number) {
    super(opacity);
  }
}
